import {
    IHistoryBonus,
    IHistoryJackpotWin,
    IHistorySpin
} from "./BURHistoryTypes";

// A spin's own win: its cascade wins, without the free spins or replay folded into creditsWon
export function getSpinWin(spin: IHistorySpin): number {
    return (spin.cascadeSteps || []).reduce(
        (sum, step) => sum + (step.creditsWon || 0),
        0
    );
}

// Every jackpot won in the spin: the ones completed on the initial landing, then those of each cascade
export function getSpinJackpotWins(spin: IHistorySpin): IHistoryJackpotWin[] {
    return (spin.cascadeSteps || []).reduce(
        (wins, step) => wins.concat(step.jackpotWins || []),
        (spin.jackpotWins || []).slice()
    );
}

// A free spin's win: its creditsWon covers the cascade wins only, so the jackpots completed in the spin
// (on the landing and in its cascades) are added. The free spins of a session then add up to its total.
export function getFreeSpinWin(spin: IHistorySpin): number {
    return getSpinJackpotWins(spin).reduce(
        (sum, jackpot) => sum + jackpot.credits,
        spin.creditsWon
    );
}

// Number of free spins and their total win (jackpots included) over the given free spins sessions
export function getFreeSpinsTotals(bonusInfo: IHistoryBonus[]): {
    count: number;
    win: number;
} {
    return bonusInfo
        .filter((bonus) => (bonus.freeSpins || []).length > 0)
        .reduce(
            (totals, bonus) => ({
                count:
                    totals.count +
                    (bonus.countFreeSpins ?? bonus.freeSpins!.length),
                win: totals.win + (bonus.creditsWon || 0)
            }),
            { count: 0, win: 0 }
        );
}
